// extracted by mini-css-extract-plugin
export default {"container":"Scanner_container__s1ySI","video":"Scanner_video__Ji2Dj"};